/* AW26 universe floating notify pill + modal.
   - Reveals the fixed pill once the visitor has scrolled down (mirrors the
     casual-toggle / size-lens floating pills): visible past REVEAL_THRESHOLD,
     hidden again near the top.
   - Clicking the pill opens a modal that contains the Klaviyo signup form
     (the form itself is wired by aw26-notify.js). Closes on backdrop, the X,
     Escape, or a successful signup. */
(function () {
  "use strict";
  var REVEAL_THRESHOLD = 320; // px scrolled before the pill slides up
  var TOP_THRESHOLD = 120;    // px — hide again when back near the top
  var lastFocus = null;
  var ticking = false;

  function pills() { return document.querySelectorAll("[data-aw26-pill]"); }

  function updateVisibility() {
    var y = window.scrollY || window.pageYOffset || 0;
    pills().forEach(function (pill) {
      // never show the pill while the modal is open
      var root = pill.closest("[data-aw26-notify-pill-root]");
      var modal = root && root.querySelector("[data-aw26-modal]");
      if (modal && !modal.hidden) { pill.classList.remove("is-visible"); return; }
      if (pill.hidden) pill.hidden = false; // un-hide so the transform transition can run
      var visible = pill.classList.contains("is-visible");
      if (y > REVEAL_THRESHOLD) visible = true;
      else if (y <= TOP_THRESHOLD) visible = false;
      pill.classList.toggle("is-visible", visible);
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { updateVisibility(); ticking = false; });
  }

  function openModal(root) {
    var modal = root.querySelector("[data-aw26-modal]");
    var pill = root.querySelector("[data-aw26-pill]");
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add("aw26-modal-open");
    if (pill) pill.classList.remove("is-visible");
    // force reflow then add the open class so the panel can transition in
    void modal.offsetWidth;
    modal.classList.add("is-open");
    var firstInput = modal.querySelector('input[name="phone"]');
    if (firstInput) firstInput.focus();
  }

  function closeModal(root) {
    var modal = root.querySelector("[data-aw26-modal]");
    if (!modal) return;
    modal.classList.remove("is-open");
    document.documentElement.classList.remove("aw26-modal-open");
    var done = function () {
      modal.hidden = true;
      modal.removeEventListener("transitionend", done);
      updateVisibility();
    };
    modal.addEventListener("transitionend", done);
    // fallback if no transition fires
    setTimeout(function () { if (!modal.classList.contains("is-open")) done(); }, 400);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function wireRoot(root) {
    if (root.dataset.aw26PillWired) return;
    root.dataset.aw26PillWired = "1";
    root.querySelectorAll("[data-aw26-pill-open]").forEach(function (b) {
      b.addEventListener("click", function () { openModal(root); });
    });
    root.querySelectorAll("[data-aw26-modal-close]").forEach(function (b) {
      b.addEventListener("click", function () { closeModal(root); });
    });
    document.addEventListener("keydown", function (e) {
      var modal = root.querySelector("[data-aw26-modal]");
      if (e.key === "Escape" && modal && !modal.hidden) closeModal(root);
    });
    // auto-close shortly after a successful Klaviyo signup
    root.addEventListener("aw26:notify:success", function () {
      setTimeout(function () { closeModal(root); }, 1600);
    });
  }

  function boot() {
    document.querySelectorAll("[data-aw26-notify-pill-root]").forEach(wireRoot);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    updateVisibility();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
